import React from 'react';

const ErrorCpfIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large" data-testid="error-cpf-container">
      <div className="vbz-icon-beneficiaries-large-error-cpf" data-testid="error-cpf-icon" />
    </div>
  );
};

export default ErrorCpfIcon;
